module.exports = __webpack_public_path__ + "img/homeDashboardBg.a820b3f3.png";